import { twMerge } from 'tailwind-merge';

interface CardContainerProps {
  children: React.ReactNode;
  containerClassName?: string;
}

export const CardContainer = ({
  children,
  containerClassName,
}: CardContainerProps) => {
  return (
    <div
      className={twMerge(
        'flex flex-1 flex-col bg-white rounded-lg px-5 py-4 shadow',
        containerClassName
      )}
    >
      {children}
    </div>
  );
};
